/* @flow */
import gql from 'graphql-tag';
/**
 * Retrieving the id is required for the InMemoryCache feature from apollo to cache data
 * if id is removed, propertyCounts will use incorrect data when rendering.
 */

export const flexibleDatesSearchRequestQuery = gql`
    query FlexibleDatesSearchRequestQuery(
        $OneWeekEarlier: SearchResultRequest!
        $OneDayEarlier: SearchResultRequest!
        $OneDayLater: SearchResultRequest!
        $OneWeekLater: SearchResultRequest!
    ) {
        oneWeekEarlierResults: search(request: $OneWeekEarlier) {
            id
            resultCount
        }
        oneDayEarlierResults: search(request: $OneDayEarlier) {
            id
            resultCount
        }
        oneDayLaterResults: search(request: $OneDayLater) {
            id
            resultCount
        }
        oneWeekLaterResults: search(request: $OneWeekLater) {
            id
            resultCount
        }
    }
`;
